import React from "react";

const Shop = () => {
  return (
    <div>
      <h1>Shop Knives</h1>
      <p>Browse our collection of Viking-inspired knives.</p>
    </div>
  );
};

export default Shop;